import { render } from "./Index.vue?vue&type=template&id=9dad54ce"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=9dad54ce&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Home/HowTo/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9dad54ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9dad54ce', __exports__)) {
    api.reload('9dad54ce', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=9dad54ce", () => {
    api.rerender('9dad54ce', render)
  })

}


export default __exports__